// Swiper Slider
class SwiperSlider extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    const swiperElement = this;
    this.slider = new window.Swiper(this.querySelector('.swiper'), {
      speed: this.speed,
      autoplay: this.autoplay,
      navigation: this.navigation,
      pagination: this.pagination,
      scrollbar: this.scrollbar,
      breakpoints: this.breakpoints,
      rewind: true,
      loop: true,
      effect: this.effect,
      fadeEffect: {
        crossFade: this.fadeSliderEffect
      }
    })

    if (this.autoplay) {
      const hoverSelector = this.dataset.hoverTarget || '.swiper';
      const hoverTarget = this.querySelector(hoverSelector);

      if (hoverTarget) {
        hoverTarget.addEventListener('mouseenter', () => {
          this.slider.autoplay.stop();
        });

        hoverTarget.addEventListener('mouseleave', () => {
          this.slider.autoplay.start();
        });
      }
    }
   if (window.screen.width>767){
    this.querySelectorAll('.pro-slider-col .swiper-slide').forEach((slide) => {
      slide.addEventListener('click', () => {
        this.slider.slideNext();
      });
    });
  }

    this.slider.on("slideChange afterInit slidesLengthChange", function () {
      const currentSlide = this.realIndex + 1;
      const totalSlides = this.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate')).length;

      swiperElement.querySelectorAll(".counter").forEach((element) => {
        element.innerHTML = `
        <span class="main-counter-box">
          <span class="counter__current">${currentSlide}</span> 
          / 
          <span class="counter__total">${totalSlides}</span>
          </span>
        `;
      });
    });

    
  }

    
  
 
  speed = Number(this.dataset.sliderSpeed)
  effect = this.dataset.effect === 'fade' ? 'fade': 'slide'
  fadeSliderEffect = this.dataset.crossfade === 'true' ? true : false;

  autoplay = this.dataset.sliderAutoplay === '0'
    ? undefined
    : { delay: Number(this.dataset.sliderAutoplay) * 1000, disableOnInteraction: false }

  navigation = {
    enabled: this.dataset.sliderNavigation === 'true',
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next'
  }

  pagination = {
    enabled: this.dataset.sliderPagination === 'true',
    el: '.swiper-pagination',
    type: 'bullets',
    dynamicBullets: true,
    dynamicMainBullets: 2,
    renderFraction: function (currentClass, totalClass) {
      return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
    }
  }

  scrollbar = {
    enabled: this.dataset.sliderScrollbar === 'true',
    el: this.querySelector('.swiper-scrollbar'),
    draggable: true
  }

  breakpoints = {
    0: { slidesPerView: Number(this.dataset.breakpointMobile) },
    600: { slidesPerView: Number(this.dataset.breakpointTablet) },
    1024: { slidesPerView: Number(this.dataset.breakpointDesktop) }
  }
}
customElements.define('swiper-slider', SwiperSlider)


document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".popup-picup");
  const toggleContent = document.querySelector(".popup_model");
  const closeBtn = document.querySelector(".popup_model .close");
  let isVisible = false;
  
  if(toggleBtn)
  {
    
    toggleBtn.addEventListener("click", function () {
      isVisible = !isVisible;
      toggleContent.style.display = isVisible ? "block" : "none";
    });

    closeBtn.addEventListener("click", function () {
     toggleBtn.click();
    });
  }
});




  setTimeout(function () {
    const prices = document.querySelectorAll(".price-item--regular, .price-item--sale,.cart-item .product-option,.cart-item__totals .price.price--end,.cart__blocks .totals__total-value");
    prices.forEach(function (el) {
      let priceText = el.textContent.trim();
      let match = priceText.match(/(\d{1,3}(,\d{3})*)(\.\d+)?/);
      if (match) {
        let withoutDecimals = match[1];
        el.textContent = priceText.replace(match[0], withoutDecimals);
      }
    });
  }, 100); // Delay for 1.5 seconds

// document.querySelectorAll('.facets__display-vertical price-range.facets__price input[type="number"]').forEach(input => {
//   input.setAttribute('type', 'range');
// });
// const currencySpan = document.querySelector('price-range.facets__price .field-currency');

// if (currencySpan) {
//   const sliderTrack = document.createElement('div');
//   sliderTrack.className = 'slider-track';

//   const sliderRange = document.createElement('div');
//   sliderRange.className = 'slider-range';
//   sliderRange.id = 'slider-range';

//   // Insert after the <span>
//   currencySpan.insertAdjacentElement('afterend', sliderTrack);
//   sliderTrack.insertAdjacentElement('afterend', sliderRange);
// }
// const sliderRange = document.getElementById("slider-range");
// const sliderMin = document.querySelector("input[name='filter.v.price.gte']");
// const sliderMax = document.querySelector("input[name='filter.v.price.lte']");

// const updateSliderRange = () => {
//   let min = parseInt(sliderMin.value);
//   let max = parseInt(sliderMax.value);
//   const minLimit = parseInt(sliderMin.min) || 0;
//   const maxLimit = parseInt(sliderMax.max) || 100;

//   if (isNaN(min) || isNaN(max)) return;

//   min = Math.max(min, minLimit);
//   max = Math.min(max, maxLimit);

//   if (min > max) {
//     [min, max] = [max, min];
//     sliderMin.value = min;
//     sliderMax.value = max;
//   }

//   const range = maxLimit - minLimit;
//   const leftPercent = ((min - minLimit) / range) * 100;
//   const rightPercent = ((max - minLimit) / range) * 100;

//   sliderRange.style.left = `${leftPercent}%`;
//   sliderRange.style.width = `${rightPercent - leftPercent}%`;
// };

// sliderMin.addEventListener("input", updateSliderRange);
// sliderMax.addEventListener("input", updateSliderRange);

// // Initialize
// updateSliderRange();


const quantity = document.querySelector(".product .product-form__quantity");
const buttons = document.querySelector(".product .product-btns");
const wishlist = document.querySelector(".shopify-app-block");
if (quantity && buttons) {
  const wrapper = document.createElement("div");
  wrapper.className = "product-qty-wrap";
 
  // Insert wrapper before the first element
  quantity.parentNode.insertBefore(wrapper, quantity,wishlist);
 
  // Move both elements inside the wrapper
  wrapper.appendChild(quantity);
  wrapper.appendChild(buttons);
  wrapper.appendChild(wishlist);
}



document.addEventListener("DOMContentLoaded", function() {
  const qtyInput = document.querySelector('input[name="quantity"]');

  if (!qtyInput) return;


  qtyInput.getAttribute("change")


});




$(function() {

  function category_search_filter()
  {
    if(document.getElementById("category_search"))
    {
      document.getElementById("category_search").addEventListener("input", function () {
          const filter = this.value.toLowerCase();
          console.log('filter',filter);
          const labels = document.querySelectorAll(".category-wrap .facet-checkbox input");
          const showMore = document.querySelector(".button-show-more");
          labels.forEach(label => {
            let labelParent = label.parentElement.parentElement;
            const text = label.value.toLowerCase();
            labelParent.style.display = text.includes(filter) ? "block" : "none";
            // if(text.includes(filter)){
            //   showMore.click();
            // }
            
          });
      }); 
    }    
  }

  
  function initPriceSlider() {
    const $slider = $(".slider-box");
    const gteInput = $(".range-input-gte");
    const lteInput = $(".range-input-lte");
  
    if ($slider.hasClass('ui-slider')) {
      $slider.slider("destroy");
    }
    
    if (!$slider.length || !gteInput.length || !lteInput.length) return;
  
    const min = parseInt($slider.data("pricemin")) || 0;
    const max = parseInt($slider.data("pricemax")) || 1000;
    const gte = parseInt(gteInput.val()) || min;
    const lte = parseInt(lteInput.val()) || max;
   
    $slider.slider({
      step: 1,
      range: true,
      min: min,
      max: max,
      values: [gte, lte],
      slide: function(event, ui) {
        gteInput.val(ui.values[0]);
        lteInput.val(ui.values[1]);
        $("#priceRange").val(ui.values[0] + " - " + ui.values[1]);
        $(".min-price-txt").text(ui.values[0]);
        $(".max-price-txt").text(ui.values[1]);
      },
      stop:function(event, ui) {
        // Trigger FacetFiltersForm render if available
        if (window.FacetFiltersForm) {
          const form = gteInput.closest("form")[0];
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          FacetFiltersForm.renderPage(searchParams, event);
        }
      }
    });
  
    $("#priceRange").val(gte + " - " + lte);
  }
  function initMobilePriceSlider() {
    const $slider = $(".mb-slider-box");
    const gteInput = $(".mb-range-input-gte");
    const lteInput = $(".mb-range-input-lte");
  
    // if ($slider.hasClass('ui-slider')) { 
    //   $slider.slider("destroy");
    // }
    
    // if (!$slider.length || !gteInput.length || !lteInput.length) return;
  
    let min = parseInt($slider.data("pricemin")) || 0;
    let max = parseInt($slider.data("pricemax")) || 1000;
    let gte = parseInt(gteInput.val()) || min;
    let lte = parseInt(lteInput.val()) || max;
   
    $slider.slider({
      step: 1,
      range: true,
      min: min,
      max: max,
      values: [gte, lte],
      slide: function(event, ui) {
        gteInput.val(ui.values[0]);
        lteInput.val(ui.values[1]);
        $(".mb-min-price-txt").text(ui.values[0]);
        $(".mb-max-price-txt").text(ui.values[1]);
      },
      stop:function(event, ui) {
        // Trigger FacetFiltersForm render if available
        if (window.FacetFiltersForm) {
          const form = gteInput.closest("form")[0];
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          FacetFiltersForm.renderPage(searchParams, event);
        }
      }
    });
  
    $("#priceRange").val(gte + " - " + lte);
  }


  
  initPriceSlider();
  initMobilePriceSlider();
  category_search_filter();

  function waitForFacetFiltersForm(callback, retries = 20) {
    if (typeof FacetFiltersForm !== "undefined") {
      callback();
    } else if (retries > 0) {
      setTimeout(() => {
        waitForFacetFiltersForm(callback, retries - 1);
      }, 100);
    } else {
      console.warn("FacetFiltersForm not found after waiting.");
    }
  }
  waitForFacetFiltersForm(() => {
    const originalRenderSectionFromFetch = FacetFiltersForm.renderSectionFromFetch;
    FacetFiltersForm.renderSectionFromFetch = async function(url, event) {
      const isAjaxSectionLoad = url.includes('section_id=');
      await originalRenderSectionFromFetch.call(this, url, event);
      setTimeout(() => {
        const sliderExists = document.querySelector('#price-range');
        if (sliderExists) {
          initPriceSlider();
          initMobilePriceSlider();
        } else {
          console.warn('Slider not found in DOM after fetch.');
        }
        category_search_filter();
      }, 1000);
    };
    
    const originalCache = FacetFiltersForm.renderSectionFromCache;
    FacetFiltersForm.renderSectionFromCache = function(filterDataFunc, event) {
      console.log('[HOOK] Cache hit — using cached HTML');
      originalCache.call(this, filterDataFunc, event);
      setTimeout(() => {
        initPriceSlider();
        category_search_filter();
        initMobilePriceSlider();
      }, 1000);
    };
  });

  // $("body").on("click", ".product__media-wrapper .product__media-icon", function(){
  //     let $current = $(this);
  //     console.log('$current',$current.parent().find(".product__media.media a"))
  //     $current.parent().find(".product__media.media img").trigger("click");
  // });







// const iframe = document.querySelector('.powr-popup iframe'); // Replace with actual iframe ID
// if (iframe) {
//   iframe.onload = function() {
//     const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
//     setTimeout(() => {
//       const watermarkSpan = iframeDoc.querySelector('.powrMark_text.powrMarkLink');
      
//       if (watermarkSpan) {
//         watermarkSpan.remove(); // Remove the element
//         console.log("Watermark removed successfully.");
//       } else {
//         console.log("Watermark element not found.");
//       }
//     }, 500); 
//   };
// }



var intr = setInterval(function () {
  const iframe = document.querySelector('.pify-form-wrap iframe');
  
  if (iframe) {
    if (iframe && iframe.contentWindow.document.readyState === 'complete') {
      console.log('state',iframe.contentWindow.document.readyState)
      console.log('iframe src:', iframe.src);
      console.log('parent origin:', window.location.origin);
      try {
        const iframeDoc = iframe.contentWindow.document;
        
        jQuery(document).on("click", ".popup_model .content-model-global button", function () {
          
          const style = document.createElement("style");
          style.setAttribute("data-added", "true");
          style.textContent = `
            #txt-73f2a615-7ea4-4cb0-bdda-8b25850edefa {
              background: red;
            }
          `;
          console.log('iframeDoc.head',iframeDoc.head)
          console.log('iframe-style',style)

          iframeDoc.head.appendChild(style);
        });
      } catch (error) {
        console.error("Iframe is cross-origin or not accessible:", error);
      }
    };

    clearInterval(intr);
  }
}, 100);







});



/* ============================================================
   MBAGH — Cart Drawer interception for .product-card-form
   Add to bottom of assets/custom.js
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer() {
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  function refreshDrawer() {
    const drawer = getCartDrawer();
    if (!drawer) return;

    fetch('/cart?view=drawer-items', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .catch(() => {});

    // Use Shopify Sections API to re-render the drawer
    fetch('/?sections=cart-drawer')
      .then(r => r.json())
      .then(data => {
        if (data['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newCartDrawer = doc.querySelector('#CartDrawer');
          const currentCartDrawer = document.querySelector('#CartDrawer');
          if (newCartDrawer && currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          }
          // Update cart count bubble
          const newBubble = doc.querySelector('#cart-icon-bubble');
          const currentBubble = document.querySelector('#cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        }
        openDrawer();
      })
      .catch(() => openDrawer());
  }

  function handleCardFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    const variantId = form.querySelector('.variant-id-input')
                   || form.querySelector('[name="id"]');
    if (!variantId) return;

    const btn = form.querySelector('.btn-add-to-cart');
    if (btn) {
      btn.disabled = true;
      btn.querySelector('span') 
        ? btn.querySelector('span').textContent = 'Adding...'
        : btn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId.value, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      refreshDrawer();
    })
    .catch(err => console.error('Cart add error:', err))
    .finally(() => {
      if (btn) {
        btn.disabled = false;
        btn.querySelector('span')
          ? btn.querySelector('span').textContent = 'Add to Cart'
          : btn.textContent = 'Add to Cart';
      }
    });
  }

  // Intercept all current .product-card-form submissions
  function bindCardForms() {
    document.querySelectorAll('.product-card-form').forEach(form => {
      if (form.dataset.drawerBound) return;
      form.dataset.drawerBound = 'true';
      form.addEventListener('submit', handleCardFormSubmit);
    });
  }

  bindCardForms();

  // Also handle dynamically added forms (e.g. sliders loaded late)
  const observer = new MutationObserver(bindCardForms);
  observer.observe(document.body, { childList: true, subtree: true });

  // Intercept cart icon to open drawer instead of navigating
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

});